import styled from 'styled-components';

const TableResumenTransactionStyled = styled.table`
  border: none;
  width: 100%;
`;

const TableResumenTransactionHeadStyled = styled.th`
  width: 50%;
`;

const TableResumenTransactionBodyStyled = styled.td`
  width: 50%;
  margin-left: 10px;
`;

const TableResumenTransactionHeadTextStyled = styled.p`
  font-size: 14px;
  line-height: 18px;
  margin: 0px 0px 8px;
  font-family: cerapro;
  font-weight: bold;
  color: #2d1441;
  text-align: left;

  @media (min-width: 769px) {
    font-size: 16px;
    line-height: 20px;
    margin: 0px 0px 12px;
  }
`;

const TableResumenTransactionBodyTextStyled = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  margin: 0px 0px 8px;
  font-family: cerapro;
  font-weight: 300;
  color: #2d1441;

  @media (min-width: 769px) {
    font-size: 16px;
    line-height: 20px;
    margin: 0px 0px 12px;
  }
`;

const TableResumenTransactionBodyImageStyled = styled.img`
  height: 20px;
  margin: 0px 8px 0px;
`;

export {
  TableResumenTransactionStyled,
  TableResumenTransactionHeadStyled,
  TableResumenTransactionHeadTextStyled,
  TableResumenTransactionBodyStyled,
  TableResumenTransactionBodyTextStyled,
  TableResumenTransactionBodyImageStyled,
};
